import { render, staticRenderFns } from "./banksetNigeria.vue?vue&type=template&id=b1c37072&scoped=true"
import script from "./banksetNigeria.vue?vue&type=script&lang=js"
export * from "./banksetNigeria.vue?vue&type=script&lang=js"
import style0 from "./banksetNigeria.vue?vue&type=style&index=0&id=b1c37072&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c37072",
  null
  
)

export default component.exports